// Twilio only delivers to German and Austrian mobile numbers (see
// queueTicketOverviewSms in the api); everything else would fail after the fact.
// Same check as checkSmsSender (functions): DE/AT mobile, national spelling read as DE.
export const canReceiveSms = (phone?: string) => {
  let digits = (phone ?? '').replace(/\D/g, '').replace(/^00/, '');
  if (digits.startsWith('0')) digits = `49${digits.slice(1)}`;
  digits = digits.replace(/^(49|43)0(?!0)/, '$1');
  return (
    digits.length > 7 &&
    /^(491[5-7]|43(?:65[0-3]|655|657|659|66[013-9]|6[7-9]\d))/.test(digits)
  );
};
